"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSS = exports.MDL = void 0;
const department_selector_style_1 = require("../../modules/department.selector/department.selector.style");
const omni_search_style_1 = require("../../modules/omni.search/omni.search.style");
const theme_1 = require("../theme");
exports.MDL = {
    button: 'mdl-button',
    title: 'mdl-layout-title',
    spacer: 'mdl-layout-spacer',
    drawer: {
        button: 'mdl-layout__drawer-button',
    },
};
exports.CSS = {
    header: {
        container: 'c-Header',
        row: 'c-Header_row',
        section: 'c-Header__section',
        sectionRight: 'c-Header__section--right',
    },
    drawer: {
        button: 'c-DrawerButton',
    },
    user: {
        menu: 'c-UserMenu',
        spacer: 'c-UserMenu__spacer',
        name: 'c-UserMenu__name',
        email: 'c-UserMenu__email',
        card: 'c-UserMenu__card',
    },
};
const SPACE_10 = theme_1.DefaultTheme.space(10);
const SPACE_8 = theme_1.DefaultTheme.space(8);
const SPACE_7 = theme_1.DefaultTheme.space(7);
(0, theme_1.addStyles)({
    [exports.CSS.header.container]: {
        height: SPACE_10,
        'min-height': SPACE_10,
        width: '100%',
        'background-color': theme_1.DefaultTheme.background.darkGrey,
        color: 'rgba(255,255,255,0.97)',
        [`& .${omni_search_style_1.CSS.container}`]: {
            flex: '1',
            height: SPACE_7,
        },
        [`& .${department_selector_style_1.CSS.container}`]: {
            'margin-left': '90px',
        },
    },
    [exports.CSS.header.row]: {
        display: 'flex',
        'flex-direction': 'row',
        'align-items': 'center',
        height: SPACE_10,
        'padding-right': theme_1.DefaultTheme.space(2),
        'min-height': SPACE_10,
        'background-color': theme_1.DefaultTheme.background.darkGrey,
        color: 'rgba(255,255,255,0.97)',
        [`& .${exports.MDL.title}`]: {
            'white-space': 'nowrap',
            'margin-right': theme_1.DefaultTheme.space(2),
        },
        '& i': {
            color: theme_1.DefaultTheme.font.color.white,
        },
    },
    [exports.CSS.header.section]: {
        display: 'flex',
        flex: 1,
        'align-items': 'center',
    },
    [exports.CSS.header.sectionRight]: {
        'justify-content': 'flex-end',
    },
    [exports.CSS.drawer.button]: {
        height: SPACE_8,
        width: SPACE_8,
        'min-height': SPACE_8,
        margin: theme_1.DefaultTheme.space(1) + ' ' + theme_1.DefaultTheme.space(3),
        // fallback to /images/favicon.svg for local development
        'background-size': 'contain',
        'background-repeat': 'no-repeat',
        cursor: 'pointer',
        'flex-shink': 0,
        '-webkit-flex-shrink': 0,
    },
    [exports.CSS.user.menu]: {
        color: theme_1.DefaultTheme.font.color.primary,
        'whites-space': 'no-wrap',
        'user-select': 'none',
    },
    [exports.CSS.user.card]: {
        'border-bottom': `1px solid ${theme_1.DefaultTheme.font.color.divider}`,
        'background-color': theme_1.DefaultTheme.background.lightGrey,
        'line-height': theme_1.DefaultTheme.space(8),
        'margin-top': theme_1.DefaultTheme.space(-2),
        padding: `${theme_1.DefaultTheme.space(2)} 0`,
        '&[disabled]': {
            'background-color': theme_1.DefaultTheme.background.lightGrey,
        },
        '&[disabled]:hover': {
            'background-color': theme_1.DefaultTheme.background.lightGrey,
        },
    },
    [exports.CSS.user.name]: {
        color: theme_1.DefaultTheme.font.color.primary,
        padding: `0 ${theme_1.DefaultTheme.space(4)}`,
    },
    [exports.CSS.user.email]: {
        color: theme_1.DefaultTheme.font.color.supporting,
        padding: `0 ${theme_1.DefaultTheme.space(4)}`,
        'line-height': theme_1.DefaultTheme.space(4),
    },
    [exports.CSS.user.spacer]: {
        height: theme_1.DefaultTheme.space(3),
        'line-height': theme_1.DefaultTheme.space(3),
    },
});
//# sourceMappingURL=banner.style.js.map